export default {
  //代码里的key(唯一标识): '阿拉伯语',
  lang: 'ar',
  appIntroduction: 'مشاهدة الفيلم والدراما الشعبية مجانا في أي وقت',
  noMoreTip: 'لقد انتهيت حتى النهاية ، لا يوجد المزيد من المحتوى ~',
  navigator: {
    home: 'الصفحة الأمامية',
    all: 'كل المحتوى',
    news: 'معلومات المقالة',
    download: 'تحميل التطبيق',
    contact: 'معلومات عنا',
    joinUs: 'انضم إلينا'
  },
  seo: {
    title: 'Loklok شاهد الأفلام عالية الدقة على الإنترنت مجانًا',
    keywords: 'Loklok ، تطبيق Loklok ، loklok tv ، موقع Loklok الرسمي ، Loklok ويب، فيلم Loklok ، شاهد على الإنترنت ، شاهد مجانًا ، شاهد الدراما مجانًا ، الأفلام ، الدراما التلفزيونية ، الدراما الكورية ، الرسوم المتحركة ، الدراما الحلوة للحيوانات الأليفة ، الدراما الأمريكية ، تدفق الوسائط ، السعادة ، قطعة واحدة ، جحيم واحد ، هاري بت ، حديقة النيزك التايلاندية، فندق اليفين ، صوت الفرح ، تصنيف الملك ، عودة السحر ،الهجوم على العملاق ، لعبة حبار، بحر الصمت ، إلخ.',
    description: 'يتم تحديث الأعمال الدرامية الشعبية بسرعة ، وتتوفر الأفلام الأمريكية والتشويق والكوميديا ​​والدراما الكورية الرومانسية والإثارة والعروض المتنوعة على الإنترنت في Loklok مع صور عالية الدقة وترجمات متعددة اللغات.',
    downloadPageKeywords: 'تنزيل Loklok ، تطبيق Loklok ، تنزيل Lokok ، Loklok ios ، Loklok الأحدث ، المشاهدة عبر الإنترنت ، المشاهدة مجانًا ، مشاهدة الأعمال الدرامية مجانًا ، Loklok للكمبيوتر الشخصي ، Loklok للكمبيوتر ، تنزيل Loklok للكمبيوتر ، تنزيل Loklok للكمبيوتر ، تنزيل Loklok للكمبيوتر ، استخدام Loklok على الكمبيوتر ، أحدث إصدار من Loklok ، كيفية استخدام Loklok على الكمبيوتر ، موقع Loklok الرسمي',
    index: {
      title: 'Loklok- مشاهدة فيديو عالي الدقة عالميًا عبر الإنترنت مسلسل تلفزيوني ساخن مجاني ضخم ، توصية أفلام عالية الدقة',
      keywords: 'Loklok ، تطبيق Loklok ، تنزيل loklok ، تنزيل loklok ، loklok pc ، loklok apk ، مشاهدة عبر الإنترنت ، مشاهدة مجانية ، مشاهدة الدراما مجانًا ، loklok ios ، loklok android ، loklok for ios ، loklok for android ، loklok android tv ، loklok chromecast ، الدراما ، الدراما الكورية ، الدراما الكورية ، شباك التذاكر ، الأفلام الأمريكية ، الأفلام الغربية ، الأفلام الرائجة ، الأفلام التايلاندية ، الأفلام التايلاندية ، الدراما التلفزيونية ، المسلسلات التلفزيونية ، الرسوم المتحركة ، الرسوم المتحركة ، برامج متنوعة ، ياوي ، يوري ، bl ، gl ، هوليوود ، بوليوود ، زومبي ، ون بيس ، ناروتو ، علاقة حب ، كلنا أموات',
      description: 'Loklok عبارة عن منصة دفق فيديو شاملة يمكنك من خلالها مشاهدة البرامج التلفزيونية والأفلام والرسوم المتحركة من جميع أنحاء العالم! مع مجموعة متنوعة من الأفلام الحصرية ، يمكنك اختيار ترجمات متعددة اللغات وبجودة صورة فائقة الدقة 4K ، يتم إصدار أفلام جديدة شهيرة كل يوم!'
    },
    allPage: {
      title: 'Loklok- مشاهدة مقاطع الفيديو العالمية عالية الدقة على الإنترنت مجانًا- أفلام ، دراما ، أنمي ، دراما أمريكية ، دراما تايلاندية ، دراما كورية ، دراما يابانية',
      keywords: 'Loklok ، تطبيق Loklok ، تنزيل loklok ، loklok للكمبيوتر الشخصي ، loklok apk ، مشاهدة على الإنترنت ، مشاهدة مجانًا ، مشاهدة الدراما مجانًا ، الرسوم المتحركة ، الرسوم المتحركة ، أفلام الأنمي ، الأفلام الرائجة ، حلقة جديدة ، الأفلام القادمة ، إصدار جديد لعام 2022 ، العرض الأول ، الخيال العلمي ، حلو رومانسي ، كوميدي ، أكشن ، حب ، أفلام مجانية ، أفلام مجانية على الإنترنت ،Zombie Campus ، Thai Meteor Garden ، الإثارة الموسم 2 ، Twenty-One One ، أشخاص من وكالة الأرصاد الجوية ، Ghost Doctor ، Goddess Descending ، Full House of Magic ، Nightmare Town ، Blind Date in the Society ، Snowdrop Flower ، أنت وأنا صف الشرطة ، الدمى المزيفة',
      description: 'يحتوي Loklok على عدد كبير من الأفلام والمحتوى التلفزيوني المتفجر ، شاهد أحدث وأهم المسلسلات التلفزيونية والأفلام مجانًا! يتوفر محتوى عالي الدقة ومتنوع وتجربة مستخدم مخصصة وأفلام وبرامج تلفزيونية شهيرة. أحدث الأفلام المشهورة ، HD عالي الدقة ، إصدار أفلام 4K ، الكوميديا ​​، الدراما الأمريكية ، ومجموعة متنوعة من الترجمات للاختيار من بينها.'
    },
    articles: {
      title: 'أخبار loklok - يتم بث أحدث المعلومات عن الأفلام والتلفزيون وأكثرها شهرة ، ومراجعات الأفلام الشهيرة ، ومجموعة الأفلام العالمية الجيدة التي تستحق المشاهدة ، ومعلومات الفيلم والتلفزيون التي تريد معرفتها يوميًا!',
      keywords: 'Loklok ، تطبيق Loklok ، تنزيل loklok ، loklok pc ، loklok apk ، المشاهدة عبر الإنترنت ، المشاهدة مجانًا ، مشاهدة الأعمال الدرامية مجانًا ، أحدث معلومات الأفلام ، الأفلام الموصى بها ، تقييمات الأفلام الشهيرة ، 2022 فيلم ، إصدارات أفلام جديدة ، 2022 تستحق المشاهدة ، مسرح 2022 أفلام ، 2023 أفلام تستحق التطلع إليها ، Peaky Blinders الموسم 6 ، Attack on Titan الموسم الأخير ، تلك السنة ، صيفنا ، فندق ترانسيلفانيا 4: مغامرة التحول ، السعادة',
      description: 'يمكن البحث عن محتوى الأفلام والتلفزيون الشهير في Loklok على الفور ، ويتم تحديث جميع أنواع تصنيفات الأفلام والمسلسلات التلفزيونية على مدار 24 ساعة في اليوم ، ويتم تقديم محتوى الأفلام والتلفزيون الشهير في الوقت الفعلي ، تعال إلى loklok عندما يكون هناك نقص في الدراما ، أحدثها ساخنة معلومات الفيلم ، تقييمات الأفلام الساخنة ، أحدث مراجعات الأفلام التلفزيونية'
    },
    download: {
      title: 'يوفر loklok أحدث إصدار رسمي لتنزيل Google play وتنزيل App Store وتنزيل apk وتنزيلات متجر التطبيقات الرئيسية ومشاهدة مقاطع الفيديو عبر الإنترنت مجانًا على هواتف loklok المحمولة',
      keywords: 'Loklok ، تطبيق Loklok ، تنزيل loklok ، loklok PC ، loklok apk ، مشاهدة عبر الإنترنت ، مشاهدة مجانًا ، مشاهدة الأعمال الدرامية مجانًا ، تنزيل loklok ، تنزيل loklok ، تنزيل loklok ، تنزيل loklok ، تنزيل loklok android ، loklok google play ، loklok pc تنزيل ، أحدث إصدار من loklok ، موقع loklok الرسمي ، كيفية تنزيل Loklok ، Loklok desktop ، Loklok pad',
      description: 'قم بتنزيل تطبيق Loklok ، يمكنك مشاهدة أحدث الأفلام والمسلسلات التلفزيونية عبر الإنترنت في المنزل أو أثناء التنقل بدقة عالية للغاية مجانًا. قم بتنزيل أحدث إصدار من تطبيق Loklok. بعد التنزيل والتثبيت ، امسح رمز الاستجابة السريعة للموقع عبر الهاتف المحمول وابدأ المشاهدة عبر الإنترنت في نفس الوقت على جهاز الكمبيوتر الخاص بك.'
    },
    search: {
      title: 'Loklok - ابحث عن أفلامك المفضلة',
      keywords: 'Loklok ، تطبيق Loklok ، تنزيل loklok ، loklok للكمبيوتر ، loklok apk ، المشاهدة عبر الإنترنت ، المشاهدة مجانًا ، مشاهدة الأعمال الدرامية مجانًا ، البحث عن الدراما ، البحث عن الحلقات ، مخططات الأفلام الشهيرة ، مخططات شباك التذاكر ، مخططات الأفلام ، مخططات المسلسلات التلفزيونية ، ترتيب الأفلام ، تقييمات الدراما الكورية ، تقييمات الدراما التايلاندية ، أفضل 10 أفلام ، أفضل 10 مسلسلات ، أفضل 100 فيلم 2022 ، أفضل 100 فيلم 2021 ، أفضل 100 فيلم 2022 الأكثر توقعًا ، 2022 فيلمًا الأكثر مشاهدة ، أفضل أفلام 2021',
      description: 'يوصي Loklok بالمسلسلات الدرامية والأفلام الأكثر شهرة عالميًا وما إلى ذلك وفقًا للتحديث اليومي في الوقت الفعلي لإجمالي المشاهدات وشعبية البحث ، لحل نقص الدراما وتحسين تجربة المشاهدة.'
    },
    contact: {
      title: 'تواصل معنا عبر البريد الإلكتروني وتويتر وفيسبوك وإنستغرام ويوتيوب. - لوكلوك',
      keywords: 'تويتر وفيسبوك وانستغرام ويوتيوب والاتصال والبريد الإلكتروني Loklok',
      description: 'يمكن إرسال الأسئلة حول loklok عبر البريد الإلكتروني  وتويتر وفيسبوك وإنستغرام ويوتيوب'
    }
  },
  globalTip: {
    emptyTip: 'تعذر تحديد موقع المورد',
    searchOther: 'حاول البحث عن أفلام أو برامج تلفزيونية أخرى'
  },
  loginModule: {
    title: 'تسجيل الدخول',
    loginMethod: 'استخدم تطبيق loklok لمسح رمز الاستجابة السريعة ضوئيًا',
    loginMethodTip: '(يجب ترقية الإصدار إلى 1.7.0 وما فوق)',
    howToDownload: 'كيفية تحميل loklok',
    clickMe: 'انقر فوقي',
    loginSuccess: 'تم تسجيل الدخول بنجاح',
    loginFailed: 'فشل تسجيل الدخول',
    codeExpired: 'انتهت صلاحية كود الاستجابة السريعة!',
    refreshButton: 'ينعش',
    loginButton: 'تسجيل الدخول',
    loginTip: 'شاهد جميع المحتويات مجانًا بعد تسجيل الدخول',
    logoutButton: 'تسجيل خروج',
    logoutTip: 'استمتع بالفيلم!',
    areYouSure: 'هل أنت متأكد أنك تريد تسجيل الخروج؟',
    sure: 'يتأكد',
    cancel: 'يلغي'
  },
  toTop: {
    downloadApp: 'تحميل التطبيق',
    backToTop: 'عد إلى الأعلى'
  },
  indexPage: {
    title: 'LolokTV',
    more: 'أكثر',
    seeMore: 'شاهد المزيد'
  },
  searchPage: {
    resultTitle: 'نتائج البحث:',
    rank: 'الأكثر شهرة على Loklok',
    play: 'يلعب',
    popularSearch: 'أعلى بحث',
    top1: 'أعلى 1',
    top2: 'أعلى 2',
    top3: 'أعلى 3',
    top4: 'أعلى 4',
    top5: 'أعلى 5',
    top6: 'أعلى 6',
    top7: 'أعلى 7',
    top8: 'أعلى 8',
    top9: 'أعلى 9',
    top10: 'أعلى 10',
    emptyTip: 'عذرا ، ليس لدينا هذا المحتوى',
    emptyDesc: 'حاول البحث عن فيلم أو دراما أخرى'
  },
  filterPage: {
    emptyTip: 'عذرا ، ليس لدينا هذا المحتوى',
    emptyDesc: 'حاول البحث عن فيلم أو دراما أخرى'
  },
  newsPage: {
    listTitle: 'أحدث الأخبار'
  },
  downloadPage: {
    scanQR: 'امسح كود QR لتنزيل التطبيق',
    title1: 'فيلم شعبي ودراما',
    tip1: 'شاهده في أي وقت مجانًا',
    title2: 'ترجمة متعددة اللغات',
    tip2: 'شاهد الدراما بسهولة',
    title3: 'مزامنة الكمبيوتر / الهاتف في الوقت الحقيقي'
  },
  detailPage: {
    autoTranslation: 'ترجمة تلقائية',
    fiveMiniteTip: 'فقط 5 دقائق ، شاهد الفيلم كاملاً بعد ذلك',
    loginTip2InDetailPage: 'استخدم تطبيق loklok لمسح كود الاستجابة السريعة أدناه لتسجيل الدخول ، وبعد ذلك يمكنك عرض بقية المحتوى',
    category: 'تصنيف',
    moreDesc: 'أكثر',
    youMayLike: 'ربما يعجبك أيضا',
    relatedSeries: 'سلسلة ذات صلة',
    norelatedSeries: 'لا توجد سلسلة ذات صلة',
    emptyDesc: 'عذرا ، ليس لدينا هذا المحتوى',
    emptyTip: 'عذرا ، ليس لدينا هذا المحتوى',
    vip: {
      dialog: {
        t1: 'افتح VIP',
        t2: 'إذا كنت ترغب في عرض جميع المحتويات ، فيرجى الانتقال إلى التطبيق لفتح VIP',
        t3: 'يمكن تنزيل التطبيق من خلال الطرق التالية',
        t4: 'هل لديك بالفعل VIP؟ يرجى <span class = "active"> النقر هنا </ span> لتسجيل الدخول',
        t5: 'لديك بالفعل VIP؟ الرجاء متابعة المشاهدة بعد <span class = "active"> التحديث </ span>',
        t6: 'لقد شاهدت {عدد} دقيقة ، إذا كنت تريد متابعة مشاهدة الفيلم بالكامل ، فيرجى استخدام التطبيق أو تنشيط VIP في التطبيق ويمكنك متابعة مشاهدة هذا الفيلم.'
      },
      player: {
        tip1: 'يمكنك المشاهدة لمدة {num} دقيقة فقط. يمكنك <span class = "active"> استخدام التطبيق </ span> أو <span class = "active"> تنشيط VIP </span> لمشاهدة الفيديو كاملاً.'
      },
      episodes: {
        tip1: 'احصل على VIP وشاهد جميع المحتويات'
      }
    }
  },
  playerModule: {
    NETWORK_LOADING: 'المتصفح يقوم بتنزيل البيانات',
    NETWORK_NO_SOURCE: 'لم يتم العثور على مصدر صوت / فيديو',
    MEDIA_ERR_ABORTED: 'تم إحباط عملية الاسترداد من قبل المستخدم',
    MEDIA_ERR_NETWORK: 'حدث خطأ أثناء التنزيل',
    MEDIA_ERR_DECODE: 'فشل تحليل التشغيل: غير قادر على تشغيل الملف',
    MEDIA_ERR_SRC_NOT_SUPPORTED: 'تنسيق الصوت / الفيديو غير مدعوم',
    REPLAY: 'اعادتها',
    ERROR: 'يبدو أن هناك مشكلة في الاتصال بالشبكة',
    PLAY_TIPS: 'يلعب',
    PAUSE_TIPS: 'إيقاف مؤقت',
    PLAYNEXT_TIPS: 'الحلقة القادمة',
    DOWNLOAD_TIPS: 'تحميل',
    ROTATE_TIPS: 'استدارة',
    RELOAD_TIPS: 'إعادة تحميل',
    FULLSCREEN_TIPS: 'أدخل ملء الشاشة',
    EXITFULLSCREEN_TIPS: 'الخروج من الشاشة الكاملة',
    CSSFULLSCREEN_TIPS: 'أدخل نمط ملء الشاشة',
    EXITCSSFULLSCREEN_TIPS: 'خروج نمط ملء الشاشة',
    TEXTTRACK: 'ترجمات',
    PIP: 'صور في صور',
    MINIPLAYER: 'لاعب صغير',
    SCREENSHOT: 'لقطة شاشة',
    LIVE: 'بث مباشر',
    OFF: 'إيقاف',
    MINIPLAYER_DRAG: 'انقر مع الاستمرار لسحب الفيديو',
    AIRPLAY_TIPS: 'إيربلاي',
    onlyPlayTip: 'قم بتشغيل {msg} دقيقة فقط ، {login} لمشاهدة الفيلم بأكمله',
    loginTextButton: 'تسجيل الدخول',
    replayButton: 'اعادتها',
    nextButton: 'الحلقة القادمة',
    refreshButton: 'ينعش',
    episode: 'حلقة',
    onlyPlayTextBtn: 'تسجيل الدخول'
  },
  contact: {
    business: 'التعاون التجاري',
    question: 'الأسئلة والتعليقات'
  },
  download_nd: {
    desc: 'شاهد الأفلام الضخمة والمسلسلات الدرامية مجانًا',
    scanQR: 'امسح رمز QR لتنزيل التطبيق أو'
  },
  win: {
    feedback: {
      que: 'شرح الأسئلة المتكررة',
      que1: ' الأسئلة المتكررة',
      content: 'محتوى التغذية الراجعة',
      contact: ' معلومات الاتصال',
      submit: 'ارسال الملاحظات',
      tip1: 'يرجى تقديم وصف مفصل، ويمكنك أيضًا تضمين لقطات الشاشة ذات الصلة.',
      tip2: 'يرجى إدخال بريدك الإلكتروني.',
      tip5: 'يجب أن يكون حجم الصورة المرفوعة أقل من {num}k.',
      tip6: ' يمكن تحميل 4 صور كحد أقصى.',
      tip3: 'تم التقديم، يرجى التحلي بالصبر.',
      tip4: 'يجب أن يتكون محتوى الملاحظات من 10 كلمات على الأقل.',
      error: 'خطأ في النظام'
    }
  },
  tv: {
    vip: {
      title: 'يرجى اختيار منتجك',
      tip1: 'يمكنك عرض رمز الاستجابة السريعة للدفع بعد تسجيل الدخول.',
      refresh: 'تحديث',
      tip2: 'امسح رمز الاستجابة السريعة للدفع',
      recharge: 'اتفاقية إعادة الشحن',
      renewal: 'اتفاقية التجديد',
      login: 'تسجيل الدخول الآن',
      tip3: 'عرض بعد تسجيل الدخول',
      noOpen: 'VIP قياسي غير مفعل',
      gift: 'هدية',
      succ: 'التحديث ناجح',
      fail: 'فشل التحديث',
      day: 'VIP القياسي لمدة يوم واحد',
      days: 'VIP القياسي لمدة {x} يوم',
      expiration: 'وقت انتهاء صلاحية VIP القياسي: {x}',
      expired: 'عضويتك VIP قد انتهت، يرجى تجديدها على الفور.',
      interests1: 'استمتع بجودة HD 1080P',
      interests2: 'افتح جميع المحتويات',
      interests3: ' تسجيل الدخول من عدة أجهزة'
    }
  }
}